import {
  object, string, ref,
} from 'yup';
import { MY_FORM_FIELD_TEXT } from '../../form/form-constants';

const nameEmail = 'email';
// const nameName = 'name';
const namePassword = 'password';
const namePasswordConfirmation = 'passwordConfirmation';

export const seedRegisterFields = [
  {
    name: nameEmail,
    type: MY_FORM_FIELD_TEXT,
    labelId: 'seed.register.form.email',
    inputProps: {
      autoFocus: true,
    },
  },
  // {
  //   name: nameName,
  //   type: MY_FORM_FIELD_TEXT,
  //   labelId: 'seed.register.form.name',
  //   inputProps: {
  //   },
  // },
  {
    name: namePassword,
    type: MY_FORM_FIELD_TEXT,
    labelId: 'seed.register.form.password',
    inputProps: {
      type: 'password',
    },
  },
  {
    name: namePasswordConfirmation,
    type: MY_FORM_FIELD_TEXT,
    labelId: 'seed.register.form.passwordConfirmation',
    inputProps: {
      type: 'password',
    },
  },
];

export const seedRegisterValidationSchema = object({
  [nameEmail]: string()
    .trim()
    .email('seed.register.form.email.valid')
    .required('seed.register.form.email.required'),
  // [nameName]: string()
  //   .trim()
  //   .required('seed.register.form.name.required'),
  [namePassword]: string()
    .min(8, 'seed.register.form.password.min')
    .required('seed.register.form.password.required'),
  [namePasswordConfirmation]: string('')
    .oneOf([ref(`${namePassword}`), null], 'seed.register.form.passwordConfirmation.match')
    .required('seed.register.form.passwordConfirmation.required'),
});
